export default __webpack_public_path__ + "static/packages-78b606b4a4375ef13bb0107831c59c2a.svg";